import { render, staticRenderFns } from "./copyGoods.vue?vue&type=template&id=4a3d6f04&scoped=true&"
import script from "./copyGoods.vue?vue&type=script&lang=js&"
export * from "./copyGoods.vue?vue&type=script&lang=js&"
import style0 from "./copyGoods.vue?vue&type=style&index=0&id=4a3d6f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3d6f04",
  null
  
)

export default component.exports